export default {
  REQUIRED_FIELD: 'validation.codes.required-field',
  NO_CHANGES: 'validation.codes.no-changes'
};
